export function calcDownloadedSize(
  recursive = true,
  win: Window = window,
  result = { transfer: 0, count: 0 },
): { transfer: number; count: number } | null {
  const resources = win.performance?.getEntriesByType?.('resource');
  for (const x of resources || []) {
    // note Safari does not report transferSize
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    result.transfer += (x as any).transferSize || 0;
    result.count++;
  }

  if (recursive) {
    // can't use for..of to access window[number]
    for (let i = 0; i < win.length; i++) {
      try {
        // try/catch is needed to avoid errors for iframes from different origins.
        calcDownloadedSize(true, win[i] as Window, result);
      } catch {
        return null;
      }
    }
  }

  return result;
}
